<template>
    <div id="portfolio_component">
        <div class="row">
            <div :class="displayType === 'new' ? 'col-lg-11' : 'col-lg-12'" style="padding: 0px;">
                <div v-if="this.stepsActive === 0" class="col-lg-12">
                    <div v-if="displayType === 'new'" class="searchAreaTitle">
                        <img src="../assets/momentGraduationCap.png"/>
                    </div>
                    <div v-if="displayType === 'new'" class="searchAreaTitle searchAreaTitleSelectClassStudent">
                        <label>{{lang('Select Class and Student')}}</label>
                    </div>
                    <div v-if="displayType === 'draft'" class="searchAreaTitleList">
                        <label>{{lang('List')}}</label>
                    </div>
                    <hr v-if="displayType === 'draft'" style="margin: 0 -15px 0 -15px;">
                    <div :class="displayType === 'new' ? 'searchAreaContent' : 'searchAreaContentList'" class="row">
                        <div class="col-lg-6">
                            <label class="searchAreaContentSelectClass">{{lang('Select Class')}}</label>
                            <!-- <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select" @change="LoadStudents()" id="ddlClass">
                                <el-option
                                        v-for="item in ddlClassList"
                                        :key="item.PK_Class_ID"
                                        :label="item.CLS_ClassName.trim() + ' ' +item.CLS_Batch.trim()"
                                        :value="item.PK_Semester_ID.trim() + ',' + item.SC_FK_CourseID.trim() + ',' + item.PK_Class_ID.trim()">
                                </el-option>
                            </el-select> -->
                            <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select" @change="LoadStudents()" id="ddlClass">
                                <el-option
                                        v-for="item in ddlClassList"
                                        :key="item.ClassID"
                                        :label="item.ClassName"
                                        :value="item.ClassID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-lg-6">
                            <label class="searchAreaContentSelectStudent">{{lang('Select Student')}}</label>
                            <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select" @change="clear('changeStudent')" id="ddlStudent">
                                <el-option
                                        v-for="item in dllStudentList"
                                        :key="item.Student_ID"
                                        :label="item.Student_Name.trim()"
                                        :value="item.Student_ID">
                                </el-option>
                            </el-select>
                        </div>
                        <div v-if="displayType === 'new'"class="col-lg-6">

                        </div>
                        <div  v-if="displayType === 'new'" class="col-lg-6" style="margin-top: 20px;">
                            <label class="searchAreaContentSelectStudent">{{lang('Select Student To Copy')}}</label>
                            <el-select v-model="ddlCopyStudent" :placeholder="lang('Select Student')" class="pro-edt-select" id="ddlCopyStudent">
                                <el-option
                                        v-for="item in dllStudentList"
                                        :key="item.Student_ID"
                                        :label="item.Student_Name.trim()"
                                        :value="item.Student_ID">
                                </el-option>
                            </el-select>
                        </div>
                        <div v-if="displayType === 'new'" class="col-lg-6">

                        </div>
                        <div v-if="displayType === 'new'" class="col-lg-6" style="margin-top: 10px;text-align: right;">
                            <el-button v-if="ddlCopyStudent !== '' && ddlStudent !== ''" class="nextNextStep" @click="copyStudent()" id="btnCopyStudent">
                                {{lang('Copy')}} >
                            </el-button>
                            <el-button class="nextNextStep" v-if="copyMomentTourName && (ddlCopyStudent === '' || ddlStudent === '')" id="btnCopyStudent">
                                {{lang('Copy')}} >
                            </el-button>
                        </div>
                    </div>
                    <div v-if="displayType === 'draft'" :class="momentEditDraftListRedBorder ? 'redborder' : ''" id="divDraftList">
                        <div v-if="portfolioListInt.length>0 && mode === 'List'" class="col-lg-12">
                            <data-tables class="listTable" :data="portfolioListInt">
                                <el-table-column v-for="portfolioListInfo in portfolioList"
                                                 :prop="portfolioListInfo.prop"
                                                 :label="portfolioListInfo.label"
                                                 :key="portfolioListInfo.prop"
                                                 sortable="custom">
                                </el-table-column>
                                <el-table-column label="Status" width="200px">
                                    <template slot-scope="scope">
                                        <button v-if="!tourRunning" @click="action(scope.row.PortfolioStatus, scope.row.PortfolioID)"
                                                class="btn btn-primary waves-effect waves-light m-r-10 portfolioActionButton">
                                            {{lang(scope.row.PortfolioStatus)}}
                                        </button>
                                        <button v-if="tourRunning"
                                                class="btn btn-primary waves-effect waves-light m-r-10 portfolioActionButton">
                                            {{lang(scope.row.PortfolioStatus)}}
                                        </button>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Action" width="200px">
                                    <template slot-scope="scope">
                                        <button v-if="!tourRunning" @click="updatePortfolio(scope.row.PortfolioID)"
                                                class="btn btn-primary waves-effect waves-light m-r-10 portfolioActionButton">
                                            {{lang('Delete')}}
                                        </button>
                                        <button v-if="tourRunning"
                                                class="btn btn-primary waves-effect waves-light m-r-10 portfolioActionButton">
                                            {{lang('Delete')}}
                                        </button>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>
                        <div v-if="mode === 'No'" class="col-lg-12 empty-list_image">
                            <strong v-if="ddlClass === ''">{{lang('Select Class')}}</strong>
                            <strong v-else-if="ddlStudent === ''">{{lang('Select Student')}}</strong>
                            <strong v-else>{{lang('Select Action')}}</strong>
                            <img src="../assets/notfound.png"/>
                        </div>
                        <div v-if="portfolioListInt.length<1 && mode === 'List'" class="col-lg-12 empty-list_image">
                            <strong>{{lang('No Moment Found')}}...</strong>
                            <img src="../assets/notfound.png"/>
                        </div>
                    </div>
                </div>

                <div v-if="this.stepsActive === 1">
                    <div v-if="displayType === 'new'" class="informationTitle">
                        <img src="../assets/momentTrip.png"/>
                    </div>
                    <div v-if="displayType === 'new'" class="informationTitle informationTitleIndicator">
                        <label>{{lang('Fill in Title and Indicator')}}</label>
                    </div>
                    <div v-if="displayType === 'draft'" class="informationTitleList row">
                        <div class="col-lg-6">
                            <label>{{lang('List')}}</label>
                        </div>
                        <div class="col-lg-6 searchAreaTitleBackToList">
                            <el-button v-if="this.stepsActive !== 0 && displayType === 'draft'" class="buttonBackToList" @click="backToList()">{{lang('Back To List')}}</el-button>
                        </div>
                    </div>
                    <hr v-if="displayType === 'draft'" style="margin: 0 0 0 0">
                    <div v-if="displayType === 'draft'" class="informationTitleClassStudentList row">
                        <div class="col-lg-6">
                            <label class="selectedClassStudentLabel">{{currentClassStudentName}}</label>
                        </div>
                        <div class="col-lg-6" style="text-align: right;">
                            <el-button v-if="approverPortfolioAction" v-on:click="approvePortfolio('REJECT')" class="actionButton btnReject">
                                {{lang('Reject')}}
                            </el-button>
                            <el-button v-if="approverPortfolioAction" v-on:click="approvePortfolio('APPROVED')" class="actionButton btnApprove">
                                {{lang('Approve')}}
                            </el-button>
                        </div>
                    </div>
                    <div class="row" :class="displayType === 'new' ? 'informationContent' : 'informationContentList'" >
                        <div class="col-lg-12">
                            <label class="informationContentTitle">{{lang('Title')}}</label>
                        </div>
                        <div class="col-lg-12 informationContentEach">
                            <el-input type="input" v-model="portfolioIitle" :disabled="mode !== 'New' && mode !== 'Draft'"></el-input>
                        </div>

                        <div class="col-lg-12">
                            <label class="informationContentIndicator">{{lang('Select Domain')}}</label>
                        </div>
                        <div class="col-lg-12 informationContentEach">
                            <el-select v-model="ddlDomain" :placeholder="lang('Select Domain')" class="pro-edt-select"
                                       :disabled="mode !== 'New' && mode !== 'Draft'">
                                <el-option
                                        v-for="item in currentDdlLearningMomentsList('Domain')"
                                        :key="item.PlnStaDomain"
                                        :label="item.PlnStaDomain"
                                        :value="item.PlnStaDomain">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-lg-12">
                            <label class="informationContentIndicator">{{lang('Select Indicator')}}</label>
                        </div>
                        <div class="col-lg-12 informationContentEach">
                            <el-select v-model="ddlIndicator" :placeholder="lang('Select Indicator')" class="pro-edt-select" @change="addIndicator()"
                                       :disabled="mode !== 'New' && mode !== 'Draft'">
                                <el-option
                                        v-for="item in currentDdlLearningMomentsList('Indicator')"
                                        :key="item.PlnStaIndicator"
                                        :label="item.PlnStaIndicator"
                                        :value="item.PlnStaIndicator">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-lg-12 informationContentEach">
                            <data-tables class="indicatorTable" :data="selectedLearningMomentsListInt">
                                <el-table-column v-for="selectedLearningMomentsListInfo in selectedLearningMomentsList" :prop="selectedLearningMomentsListInfo.prop"
                                                 :label="selectedLearningMomentsListInfo.label" :key="selectedLearningMomentsListInfo.prop"
                                                 sortable="custom">
                                </el-table-column>
                                <el-table-column label="Delete" width="200px">
                                    <template slot-scope="scope">
                                        <button @click="removeIndicator(scope.row)" :disabled="mode !== 'New' && mode !== 'Draft'"
                                                class="btn btn-primary waves-effect waves-light m-r-10 portfolioActionButton">
                                            {{lang('Delete')}}
                                        </button>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>

                        <div class="col-lg-12" v-if="approverPortfolioAction">
                            <label class="informationContentTitle">{{lang('Approver Comment')}}</label>
                        </div>
                        <div class="col-lg-12 informationContentEach" v-if="approverPortfolioAction">
                            <el-input type="input" v-model="commentAll"></el-input>
                        </div>
                        <div v-for="value in portfolioCommentHistoryList" class="col-lg-12 informationContentEach"
                             v-if="value.AppComValue !== undefined && value.AppComDesc==='All' && value.AppComType==='Portfolio Header'">
                            <div class="row">
                                <div class="col-6">
                                    <label>
                                        {{ value.AppComValue }}
                                    </label>
                                </div>
                                <div class="col-6">
                                    <label class="preview-comment__commenter" style="text-align: right;">
                                        <span>{{lang('Commenter')}}: {{ value.CONname }}</span>
                                        <span>{{lang('Date')}}: {{ value.AppComCreatedDate_convert }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="this.stepsActive === 2">
                    <div v-if="displayType === 'draft'" class="informationTitleList row">
                        <div class="col-lg-6">
                            <label>{{lang('List')}}</label>
                        </div>
                        <div class="col-lg-6 searchAreaTitleBackToList">
                            <el-button v-if="this.stepsActive !== 0 && displayType === 'draft'" class="buttonBackToList" @click="backToList()">Back To List</el-button>
                        </div>
                    </div>
                    <hr v-if="displayType === 'draft'" style="margin: 0 0 0 -15px;">
                    <div v-if="displayType === 'draft'" class="informationTitleClassStudentList row">
                        <div class="col-lg-6">
                            <label class="selectedClassStudentLabel">{{currentClassStudentName}}</label>
                        </div>
                        <div class="col-lg-6" style="text-align: right;">
                            <el-button v-if="approverPortfolioAction" v-on:click="approvePortfolio('REJECT')" class="actionButton btnReject">
                                {{lang('Reject')}}
                            </el-button>
                            <el-button v-if="approverPortfolioAction" v-on:click="approvePortfolio('APPROVED')" class="actionButton btnApprove">
                                {{lang('Approve')}}
                            </el-button>
                        </div>
                    </div>
                    <!--<div class="editor col-lg-12" id="gjs"></div>-->
                    <div v-if="(mode === 'New' || mode === 'Draft')" class="selfEditorFuncDiv">
                        <el-button v-on:click="updateEditorPage('Add')" class="btnDraft">
                            {{lang('Add Page')}}
                        </el-button>
                        <el-button v-on:click="updateEditorPage('Delete')" class="btnDraft">
                            {{lang('Delete Page')}}
                        </el-button>
                        <div class="delete-selected-item-container" style="float: right;">
                        </div>
                    </div>
                    <div class="editor col-lg-12">
                        <vue-page-designer
                            :value="editorValue"
                            :upload-option="uploadOption"
                            :upload="editorHandleUpload"
                            @save="editorHandleSave" v-if="isRerender"
                        />
                    </div>
                </div>

                <div v-if="this.stepsActive === 999">
                    <div v-if="displayType === 'new'" style="min-height: 500px;">
                        <div v-if="copyStudentPortfolioListInt.length>0" class="col-lg-12">
                            <div style="margin: 20px 0px;">
                                <label v-if="selectedCopyStudentPortfolioTitle === ''">
                                    Select Moments To Copy
                                </label>
                                <label v-if="selectedCopyStudentPortfolioTitle !== ''">
                                    Seleted Moments: {{selectedCopyStudentPortfolioTitle}}
                                </label>
                            </div>
                            <data-tables class="listTable" :data="copyStudentPortfolioListInt">
                                <el-table-column v-for="copyStudentPortfolioListInfo in copyStudentPortfolioList"
                                                 :prop="copyStudentPortfolioListInfo.prop"
                                                 :label="copyStudentPortfolioListInfo.label"
                                                 :key="copyStudentPortfolioListInfo.prop"
                                                 sortable="custom">
                                </el-table-column>
                                <el-table-column label="Action" width="200px">
                                    <template slot-scope="scope">
                                        <button @click="selectCopyPortfolio(scope.row)" class="btn btn-primary waves-effect waves-light m-r-10 portfolioActionButton">
                                            {{lang('Select')}}
                                        </button>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>
                        <div v-if="copyStudentPortfolioListInt.length<1" class="col-lg-12 empty-list_image">
                            <strong>{{lang('No Moment Found')}}...</strong>
                            <img src="../assets/notfound.png"/>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12 divButton">
                    <div class="row ">
                        <div class="col-lg-6 divButtonLeft">
                            <el-button v-if="this.stepsActive !== 0 && displayType === 'new'" class="buttonPreviousStep" @click="previousStep()">< {{lang('Previous Step')}}</el-button>
                            <el-button v-if="this.stepsActive === 2 && displayType === 'draft'" class="buttonPreviousStep" @click="previousStep()">< {{lang('Information')}}</el-button>
                        </div>

                        <div class="col-lg-6 divButtonRight">
                            <el-button v-if="this.stepsActive !== 2 && displayType === 'new' && !this.tourRunning" class="nextNextStep" @click="nextStep()">{{lang('Next Step')}} ></el-button>
                            <el-button v-if="this.stepsActive !== 2 && displayType === 'new' && this.tourRunning" class="nextNextStep" id="btnNextStep">{{lang('Next Step')}} ></el-button>
                            <el-button v-if="(mode === 'New' || mode === 'Draft') && this.stepsActive === 2" v-on:click="savePortfolio('Draft')" class="btnDraft">{{lang('Save as Draft')}}</el-button>
                            <el-button v-if="(mode === 'New' || mode === 'Draft') && this.stepsActive === 2" v-on:click="savePortfolio('New')" class="btnSubmit">{{lang('Submit')}}</el-button>
                            <el-button v-if="this.stepsActive === 1 && displayType === 'draft'" class="nextNextStep" @click="nextStep()">{{lang('Editor')}} ></el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-1 stepStep" v-if="displayType === 'new'">
                <div>
                    <el-steps class="elStep" :active="stepsActive" direction="vertical">
                        <el-step></el-step>
                        <el-step></el-step>
                        <el-step></el-step>
                    </el-steps>
                </div>
            </div>
        </div>
        <v-tour name="momentTourName" :steps="momentTour" :options="momentTourOptions" :callbacks="momentTourCallBacks">
            <template slot-scope="tour">
                <transition name="fade">
                    <v-step v-if="tour.currentStep === index"
                            v-for="(step, index) of tour.steps"
                            :key="index"
                            :step="step"
                            :previous-step="tour.previousStep"
                            :next-step="tour.nextStep"
                            :stop="tour.stop"
                            :is-first="tour.isFirst"
                            :is-last="tour.isLast"
                            :labels="tour.labels">
                        <template v-if="tour.currentStep === 0">
                            <div slot="actions">
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Stop')">Skip</button>
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Next')">Next</button>
                            </div>
                        </template>
                        <template v-if="tour.currentStep !== 0 && tour.currentStep + 1 !== tour.steps.length">
                            <div slot="actions">
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Stop')">Skip</button>
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Previous')">Previous</button>
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Next')">Next</button>
                            </div>
                        </template>
                        <template v-if="tour.currentStep + 1 === tour.steps.length">
                            <div slot="actions">
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Stop')">Skip</button>
                                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Previous')">Previous</button>
                            </div>
                        </template>
                    </v-step>
                </transition>
            </template>
        </v-tour>
        <v-tour name="momentEditTourName" :steps="momentEditTour" :options="momentEditTourOptions" :callbacks="momentEditTourCallBacks">
            <template slot-scope="tour">
                <transition name="fade">
                    <v-step v-if="tour.currentStep === index"
                            v-for="(step, index) of tour.steps"
                            :key="index"
                            :step="step"
                            :previous-step="tour.previousStep"
                            :next-step="tour.nextStep"
                            :stop="tour.stop"
                            :is-first="tour.isFirst"
                            :is-last="tour.isLast"
                            :labels="tour.labels">
                        <template v-if="tour.currentStep === 0">
                            <div slot="actions">
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Stop')">Skip</button>
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Next')">Next</button>
                            </div>
                        </template>
                        <template v-if="tour.currentStep !== 0 && tour.currentStep + 1 !== tour.steps.length">
                            <div slot="actions">
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Stop')">Skip</button>
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Previous')">Previous</button>
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Next')">Next</button>
                            </div>
                        </template>
                        <template v-if="tour.currentStep + 1 === tour.steps.length">
                            <div slot="actions">
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Stop')">Skip</button>
                                <button class="v-step__button" @click="momentEditTourNexPreviousStep(tour, 'Previous')">Previous</button>
                            </div>
                        </template>
                    </v-step>
                </transition>
            </template>
        </v-tour>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import 'grapesjs/dist/css/grapes.min.css';
    import grapesjs from 'grapesjs';
    import 'grapesjs-blocks-basic';
    import 'grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.css';
	import {lang} from '../locale/index';
    import $ from 'jquery';
    import Vue from 'vue';
    import VueTour from 'vue-tour';
    require('vue-tour/dist/vue-tour.css');
    Vue.use(VueTour);

    export default {
        name: "PortfolioNew",
        props: ["portFiles", "displayViewType", "paramPortfolio", "passMomentTourData"],
        watch: {
            portFiles: function(newVal, oldVal) { // watch it
                this.selectedFiles = oldVal;

                if (newVal && newVal !== oldVal) {
                    this.selectedFiles = newVal;
                }

                if (this.mode === 'New' || this.mode === 'Draft') {

                    this.selectedFiles.forEach(selectedFile => {
                        let url1 = selectedFile.FilePath;
                        let fileName = selectedFile.GalFileName;
                        let mimeType = selectedFile.GalFileType;
                        this.urltoFile(url1, fileName, mimeType).then((file) => {
                            var url = window.URL.createObjectURL(file);
                            var img = new Image();
                            img.src = url;
                            // img.onload = () => {
                            //     this.onloadImage.width = img.width;
                            //     this.onloadImage.height = img.height;
                            // };

                            let self = this;

                            var promise = new Promise(function(resolve, reject) {
                                // A new promise is "pending"
                                img.onload = () => {
                                    resolve(img);
                                };
                                img.onerror = function() {
                                    // Rejecting a promise changes its state to "rejected"
                                    reject(new Error('loadImage Error'));
                                };
                            }).then(function(results) {
                                let maxWidth = 700;
                                let imgWidth = results.width;
                                let imgHeight = results.height;

                                if (imgWidth >= maxWidth) {
                                    let newWidth = -100;
                                    let newHeight = -100;
                                    let deductPercentage = Math.round((imgWidth - maxWidth) * 100 / maxWidth);

                                    if (deductPercentage <= 100) {
                                        newWidth = imgWidth * (100 - deductPercentage) / 100;
                                        newHeight = imgHeight * (100 - deductPercentage) / 100;
                                    } else {
                                        newWidth = imgWidth / ((deductPercentage / 100) + 1);
                                        newHeight = imgHeight / ((deductPercentage / 100) + 1);
                                    }

                                    imgWidth = newWidth;
                                    imgHeight = newHeight;
                                }

                                let randomuuid = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                                self.editorValue.widgets.push({
                                    // width: 200, //this.onloadImage.width,
                                    // height: 200, //this.onloadImage.height,
                                    width: imgWidth,
                                    height: imgHeight,
                                    top: 0,
                                    url: url1, // 图片预览地址
                                    src: 'images/' + file.name, // 图片实际地址
                                    animationName: "",
                                    belong: "page",
                                    dragable: true,
                                    hasGuide: true ,
                                    href: "",
                                    isChild: true,
                                    isContainer: false,
                                    isUpload: true,
                                    left: 0,
                                    resizable: true,
                                    top: 0,
                                    type: "braid-pic",
                                    uuid:randomuuid ,
                                    z: 0,
                                    filePath: url1,
                                    rotate: 0,
                                });
                            });
                        }).finally(() => {
                            // this.getImagePreviews();

                            this.isRerender = false;

                            $(".delete-selected-item-container .btn-delete-selected").remove();

                            this.$nextTick(() => {
                                // Add the component back in
                                this.isRerender = true;
                            });
                        });
                    });

                    // this.addFiles(this.selectedFiles);
                }
            },
            displayViewType: function(newVal, oldVal) { // watch it
                this.displayType = oldVal;

                if (newVal && newVal !== oldVal) {
                    this.displayType = newVal;
                }

                if(!this.boolFirstTime){
                    this.stepsActive = 0 ;
                    this.clear('All');
                }
            },
            paramPortfolio: function(newVal, oldVal) { // watch it
                if(this.boolFirstTime && newVal !== ''){
                    var checkID = newVal.substring(0, 3);

                    if (checkID === 'POR') {
                        this.action('Approver',newVal);
                    } else {
                        if (this.$route.query.portfolioid !== undefined) {
                            this.action('ApproverWithLink',decodeURI(newVal));
                        }

                        this.$router.replace({'query': null});
                    }
                }
            },
            passMomentTourData: function(newVal, oldVal) { // watch it
                if (newVal === 'momentTour'){
                    this.momentTourStart();
                } else if (newVal === 'momentEditTour') {
                    this.momentEditTourStart();
                }
            },
        },
        data() {
            return {
                editorValue: null,
                uploadOption: {
                    url: 'https://jsonplaceholder.typicode.com/photos'
                },
                editorScreenHight: 1122,
                currentBlobConvertion: '',
                isRerender: true,
                byPassToken: 'BYPASSTOKEN999111000333',
                boolFirstTime: true,
                stepsActive: 0,
                displayType: '',
                ddlStudent: '',
                dllStudentList: [],
                ddlClass: '',
                ddlClassList: [],
                portfolioIitle: '',
                currentPortfolioID: '',
                currentClassStudentName: '',
                approverPortfolioAction: false,
                downLoadButton: false,
                mode: 'No',
                remarkShow: false,
                remarkAll: false,
                commentAll: '',
                ddlDomain: '',
                ddlIndicator: '',
                ddlLearningMomentsList: [],
                portfolioCommentHistoryList: [],

                portfolioListInt: [],
                portfolioList: [{
                    prop: "PortfolioTitle",
                    label: "Title"
                }],

                selectedLearningMomentsListInt: [],
                selectedLearningMomentsList: [{
                    prop: "PlnStaDomain",
                    label: "Domain"
                }, {
                    prop: "PlnStaGoals",
                    label: "Goals"
                }, {
                    prop: "PlnStaIndicator",
                    label: "Indicator"
                }],
                actionCol: {
                    label: 'Delete',
                    props: {
                        align: 'center',
                    },
                    buttons: [{
                        props: {
                            type: 'primary',
                        },
                        handler: row => {
                            this.selectedLearningMomentsListInt.splice(this.selectedLearningMomentsListInt.indexOf(row), 1);
                        },
                        label: 'Delete'
                    },]
                },

                selectedFiles: [],
                onloadImage:{
                    size:'',
                    height:'',
                    width:''
                },

                ddlCopyStudent: '',
                selectedCopyStudentPortfolioID: '',
                selectedCopyStudentPortfolioTitle: '',

                copyStudentPortfolioListInt: [],
                copyStudentPortfolioList: [{
                    prop: "PortfolioTitle",
                    label: "Title"
                }],

                //vue tour
                tourRunning: false,

                copyMomentTourName: false,
                momentTourOptions: {
                    useKeyboardNavigation: false,
                    labels: {
                        buttonSkip: 'Skip tour',
                        buttonPrevious: 'Previous',
                        buttonNext: 'Next',
                        buttonStop: 'Finish'
                    }
                },
                momentTourCallBacks: {
                    // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
                    // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
                },
                momentTour: [
                    //Level Tab
                    {
                        target: '#ddlClass',
                        content: `<div class="studentPageTourDiv">Step 2 / 6 <br>Select Class</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                    {
                        target: '#ddlStudent',
                        content: `<div class="studentPageTourDiv">Step 3 / 6 <br>Select Student</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                    {
                        target: '#ddlCopyStudent',
                        content: `<div class="studentPageTourDiv">Step 4 / 6 <br>Select Student to Copy, else ignore</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                    {
                        target: '#btnCopyStudent',
                        content: `<div class="studentPageTourDiv">Step 5 / 6 <br>Copy Student, else ignore<br>Select the moments want to copy and click Next Step button<br>Fill in moment information and click Next Step button<br>Design and Submit or Draft</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                    {
                        target: '#btnNextStep',
                        content: `<div class="studentPageTourDiv">Step 6 / 6 <br>Click Next Step button<br>Fill in moment information and click Next Step button<br>Design and Submit or Draft</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                ],

                momentEditDraftListRedBorder: false,
                momentEditTourOptions: {
                    useKeyboardNavigation: false,
                    labels: {
                        buttonSkip: 'Skip tour',
                        buttonPrevious: 'Previous',
                        buttonNext: 'Next',
                        buttonStop: 'Finish'
                    }
                },
                momentEditTourCallBacks: {
                    // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
                    // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
                },
                momentEditTour: [
                    //Level Tab
                    {
                        target: '#ddlClass',
                        content: `<div class="studentPageTourDiv">Step 2 / 4 <br>Select Class</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                    {
                        target: '#ddlStudent',
                        content: `<div class="studentPageTourDiv">Step 3 / 4 <br>Select Student</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                    {
                        target: '#divDraftList',
                        content: `<div class="studentPageTourDiv">Step 4 / 4 <br>Click on the status column to edit drat<br>Click on the Action column to delete draft</div>`,
                        params: {
                            placement: 'top',
                        }
                    },
                ],
                //vue tour
            };
        },
        async created() {
            this.BindClasses();
        },
        async mounted() {
            this.editor = grapesjs.init({
                container: '#gjs',
                fromElement: 1,
                height: '500px',
                width: 'auto',
                plugins: ['gjs-blocks-basic','gjs-preset-webpage'],
                pluginsOpts: {
                    'gjs-blocks-basic': {
                        flexGrid: true,
                        blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'map'],
                    },
                    "gjs-components":[],
                },
            });

            const prop = this.editor.StyleManager.getProperty('typography', 'font-family');
            prop.set('options', [
                {value: "'Arial ', Arial ", name: 'Arial '},
                {value: "'KaiTi ', KaiTi ", name: 'KaiTi '},
            ]);

            //clear editor
            this.editor.DomComponents.clear();
            this.editor.CssComposer.clear();
            this.editor.UndoManager.clear();

            //approver
            // if (this.$route.params.mode !== undefined) {
            //     this.action('Approver',this.$route.params.portfolioID);
            // } else if (this.$route.query.id !== undefined) {
            //     this.action('ApproverWithLink',decodeURI(this.$route.query.id));
            // }

            // menu-bar toolbar column
            $(document).ready(function(){
                $(".menu-bar.toolbar.column").appendTo(".control-panel.column");
            });

            // if (this.$route.query.tour === 'moment') {
            //     this.momentTourStart();
            // }
        },
        methods: {
			lang,
            async BindClasses() {
                try {
                    // const response = await DataSource.shared.getAttendanceClass();
                    const response = await DataSource.shared.getAttendanceClassWithMode('GroupClasName');
                    if (response) {
                        if (response.code === '2') {
                            console.log('Get Attendance Class: No Record');
                        } else if (response.code === '99') {
                            console.log('Get Attendance Class: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            // this.ddlClassList = response.Table;
                            this.ddlClassList = response.dsGroupClass.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async LoadStudents() {
                try {
                    this.clear('changeClass','');

                    this.$vs.loading();

                    // const response = await DataSource.shared.LoadAttendanceList(this.ddlClass);
                    const response = await DataSource.shared.LoadAttendanceListWithMode(this.ddlClass, 'GroupClasName');
                    if (response) {
                        if (response.code === '2') {
                            this.$notify.error({
                                title: 'Error',
                                message: 'No Student Found...'
                            });
                        } else if (response.code === '99') {
                            console.log('Load Attendance List: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            this.dllStudentList = response.Table;
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },
            async LoadPortfolioList(studentID) {
                try {
                    this.$vs.loading();

                    let studentIDToPass = '';
                    if (studentID === '') {
                        studentIDToPass = this.ddlStudent;
                    } else {
                        studentIDToPass = studentID;
                    }

                    const response = await DataSource.shared.getPortfolioListByStudentID(studentIDToPass);
                    if (response) {
                        if (response.code === '2') {
                            console.log('Get Portfolio List By Student ID: No Record');
                        } else if (response.code === '99') {
                            console.log('Get Portfolio List By Student ID: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            if (studentID === '') {
                                response.Table.forEach(m => {
                                    if(m.PortfolioStatus !== 'Approved'){
                                        this.portfolioListInt.push(m);
                                    }
                                });
                            } else {
                                response.Table.forEach(m => {
                                    if(m.PortfolioStatus === 'Approved'){
                                        this.copyStudentPortfolioListInt.push(m);
                                    }
                                });
                            }
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },
            async GetStudentPlanner(){
                let StudentIDList = [];

                let tempStudentIDList = {
                    StudentID: this.ddlStudent,
                };

                StudentIDList.push(tempStudentIDList);

                let currentClassID = this.ddlClass.split(',');

                const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(currentClassID[2], JSON.stringify(StudentIDList));

                if (response) {
                    if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === '99') {
                        console.log('getPlannerAssignedStudentsGroupByClassID Error');
                    } else if (response.code === '2') {
                        console.log('getPlannerAssignedStudentsGroupByClassID no record');
                    } else {
                        this.ddlLearningMomentsList = response.Table;
                    }
                }
            },
            async savePortfolio(mode) {
                try {
                    if (this.portfolioIitle === '') {
                        this.$notify.error({
                            title: 'Required',
                            message: 'Please fill in title...'
                        });
                    } else if (this.selectedLearningMomentsListInt.length < 1){
                        this.$notify.error({
                            title: 'Required',
                            message: 'Please select at least one Indicator...'
                        });
                    // } else if (this.editor.getHtml() === '') {
                    //     this.$notify.error({
                    //         title: 'Required',
                    //         message: 'Empty template not allow...'
                    //     });
                    } else {
                        this.$vs.loading();

                        let learningMoment = [];
                        this.selectedLearningMomentsListInt.forEach(m => {
                            let tempDs = {
                                Domain: m.PlnStaDomain,
                                Goals: m.PlnStaGoals,
                                Indicator: m.PlnStaIndicator,
                            };

                            learningMoment.push(tempDs);
                        });

                        let objEditor = $('.tooltip-bottom');
                        for (var a = 0; a < objEditor.length; a++) {
                            if ($('.tooltip-bottom')[a].innerText.trim() === '保存') {
                                $('.tooltip-bottom')[a].click();
                            }
                        }

                        // const response = await DataSource.shared.savePortfolio(mode, this.ddlStudent, this.portfolioIitle, this.currentPortfolioID, encodeURI(this.editor.getHtml()), encodeURI('<style>' + this.editor.getCss() + '</style>'), JSON.stringify(learningMoment));
                        const response = await DataSource.shared.savePortfolio(mode, this.ddlStudent, this.portfolioIitle, this.currentPortfolioID, encodeURI($('#viewport')[0].innerHTML), encodeURI(JSON.stringify(this.editorValue)), JSON.stringify(learningMoment));

                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                console.log('savePortfolio error');
                            } else if (response.code === '2') {
                                console.log('savePortfolio no record');
                            } else {
                                if (mode === 'New') {
                                    this.$notify({
                                        title: 'Submitted',
                                        message: 'Moment Submitted...'
                                    });
                                } else if (mode === 'Draft') {
                                    this.$notify({
                                        title: 'Saved',
                                        message: 'Moment Saved...'
                                    });
                                }

                                this.clear('All');
                                this.stepsActive = 0;
                            }
                        }

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async getPortfolio(portfolioID){
                try {
                    let byPassToken = '';
                    let passPortfolioID = '';
                    if (portfolioID === '') {
                        passPortfolioID = this.currentPortfolioID;
                        byPassToken = '';
                    } else {
                        passPortfolioID = portfolioID;
                        byPassToken = this.byPassToken;
                    }

                    const response = await DataSource.shared.getPortfolioHeaderDetails(passPortfolioID, byPassToken);
                    if (response) {
                        if (response.code === '2') {
                            console.log('Get Portfolio Header Details: No Record');
                        } else if (response.code === '99') {
                            console.log('Get Portfolio Header Details: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            // this.editor.addComponents(response.HeaderTable.Table[0].PortfolioTempHtml);
                            // this.editor.setStyle(response.HeaderTable.Table[0].PortfolioTempCss);

                            let objGetEditorHeight = JSON.parse(response.HeaderTable.Table[0].PortfolioTempCss);
                            this.editorScreenHight = objGetEditorHeight.page.height;

                            window.localStorage.setItem('vpd-data', response.HeaderTable.Table[0].PortfolioTempCss);
                            let data = window.localStorage.getItem('vpd-data');
                            this.editorValue = JSON.parse(data);
                            this.isRerender = false;
                            this.$nextTick(() => {
                                // Add the component back in
                                this.isRerender = true;
                            });

                            this.portfolioIitle = response.HeaderTable.Table[0].PortfolioTitle;

                            //for approver link
                            if(portfolioID !== ''){
                                this.currentPortfolioID = response.HeaderTable.Table[0].PortfolioID;
                                this.checkApprover();
                                this.getPortfolioComment();
                                this.stepsActive = 1;
                            }
                            //for approver link

                            response.LearningMoments.Table.forEach(m => {
                                let tempDs = {
                                    Included: 'No',
                                    PlnStaDomain: m.PortfolioLMDomain,
                                    PlnStaGoals: m.PortfolioLMGoals,
                                    PlnStaIndicator: m.PortfolioLMIndicator,
                                };

                                this.selectedLearningMomentsListInt.push(tempDs);
                            });
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async checkApprover() {
                try {
                    const response = await DataSource.shared.checkApproveStatusByUser(this.currentPortfolioID, "PORTFOLIO");
                    if (response) {
                        if (response.code === '1') {
                            this.approverPortfolioAction = true;
                        } else {
                            this.approverPortfolioAction = false;
                        }

                        if (response.code === '5') {
                            this.downLoadButton = true;
                        } else {
                            this.downLoadButton = false;
                        }

                        this.remarkShow = true;
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async getPortfolioComment() {
                try {
                    const response = await DataSource.shared.getApproverComment(this.currentPortfolioID);
                    if (response) {
                        if (response.code === '2') {
                            console.log('Get Approver Comment: No Record');
                        } else if (response.code === '99') {
                            console.log('Get Approver Comment: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            this.portfolioCommentHistoryList = response.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async approvePortfolio(mode) {
                try {
                    this.$vs.loading();

                    let jsonHeaderComment = [];
                    let tempJsonHeaderComment = {
                        Value: this.commentAll,
                    };
                    jsonHeaderComment.push(tempJsonHeaderComment);

                    const response = await DataSource.shared.approvePortfolio(this.currentPortfolioID, mode, JSON.stringify(jsonHeaderComment), '');
                    if (response) {
                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Error on Approver Action'
                                });
                            } else {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Successfully on Approver Action'
                                });

                                this.clear('All');
                            }
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },
            async generatePortfolioPdf() {
                try {
                    this.$vs.loading();
                    const response = await DataSource.shared.generatePortfolioPDF(this.currentPortfolioID);
                    if (response) {
                        this.$vs.loading.close();

                        var byteChar = atob(response);
                        var byteNo = new Array(byteChar.length);
                        for (var i = 0; i < byteChar.length; i++) {
                            byteNo[i] = byteChar.charCodeAt(i);
                        }

                        var byteArray = new Uint8Array(byteNo);
                        var file = new Blob([byteArray], {type: 'application/pdf;base64'});
                        var fileUrl = URL.createObjectURL(file);

                        window.open(fileUrl, '_blank', 'width=500, height=500');

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async updatePortfolio(portfolioID) {
                try {
                    this.$vs.loading();

                    const response = await DataSource.shared.updatePortfolio(portfolioID, 'Void');
                    if (response) {
                        if (response.code === '99') {
                            console.log('Update Portfolio: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            this.$notify.success({
                                title: 'Successful',
                                message: 'Moments Deleted...'
                            });

                            this.clear('changeStudent');
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },
            fnCurrentClassStudentName(){
                this.currentClassStudentName = 'Error';

                // let currentClassID = this.ddlClass.split(',');
                // let currentClassName = this.ddlClassList.filter(m => m.PK_Class_ID === currentClassID[2]);
                let currentClassName = this.ddlClassList.filter(m => m.ClassID === this.ddlClass);

                let currentStudentName = this.dllStudentList.filter(m => m.Student_ID === this.ddlStudent);

                // this.currentClassStudentName = currentClassName[0].CLS_ClassName;
                this.currentClassStudentName = currentClassName[0].ClassName;
                this.currentClassStudentName += ' > ' + currentStudentName[0].First_Name;

                if (currentStudentName[0].Middle_Name !== '') {
                    this.currentClassStudentName += ' ' + currentStudentName[0].Middle_Name;
                    this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name;
                } else {
                    this.currentClassStudentName += ' ' + currentStudentName[0].Last_Name;
                }
            },
            clear(value){
                this.boolFirstTime = false;
                this.portfolioIitle = '';
                this.portfolioListInt = [];
                this.currentPortfolioID = '';
                this.remarkShow = false;
                this.remarkAll = false;
                this.ddlIndicator = '';
                this.ddlDomain = '';
                this.selectedLearningMomentsListInt = [];
                this.commentAll = '';
                this.approverPortfolioAction = false;
                this.downLoadButton = false;
                this.portfolioCommentHistoryList = [];
                this.ddlLearningMomentsList = [];
                this.ddlCopyStudent = '';
                this.copyStudentPortfolioListInt = [];
                this.selectedCopyStudentPortfolioID = '';
                this.selectedCopyStudentPortfolioTitle = '';

                this.editor.DomComponents.clear();
                this.editor.CssComposer.clear();
                this.editor.UndoManager.clear();

                this.clearEditor();

                if (value === 'All') {
                    this.dllStudentList = [];
                    this.ddlStudent = '';
                    this.ddlClass = '';
                    this.mode = 'No';
                } else if (value === 'changeStudent') {
                    this.mode = 'No';
                    this.fnCurrentClassStudentName();
                    if (this.displayType === 'draft') {
                        this.action('List', '');
                    }
                } else if (value === 'changeClass') {
                    this.dllStudentList = [];
                    this.ddlStudent = '';
                    this.mode = 'No';
                } else if (value === 'changeAction') {

                }
            },
            action(value, portfolioID){
                if (value === 'New'){
                    if (this.ddlClass === '' || this.ddlStudent === '') {
                        this.$notify({
                            title: 'Required',
                            message: 'Please select student....'
                        });
                    } else {
                        this.mode = 'New';
                        this.clear('changeAction');
                        this.GetStudentPlanner();
                    }
                } else if (value === 'List') {
                    if (this.ddlClass === '' || this.ddlStudent === '') {
                        this.$notify({
                            title: 'Required',
                            message: 'Please select student....'
                        });
                    } else {
                        this.mode = 'List';
                        this.clear('changeAction');
                        this.LoadPortfolioList('');
                    }
                } else if (value === 'Draft') {
                    if (portfolioID === '' || portfolioID === null || portfolioID === undefined) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Error getting data from this Learning Journey, please contact IT...'
                        });
                    } else {
                        this.mode = 'Draft';
                        this.clear('changeAction');
                        this.currentPortfolioID = portfolioID;
                        this.GetStudentPlanner();
                        this.getPortfolio('');
                        this.stepsActive = 1;
                    }
                } else if (value === 'Approved') {
                    // this.mode = 'View';
                    // this.clear('changeAction');
                    // this.currentPortfolioID = portfolioID;
                    // this.getPortfolio('');
                    // this.checkApprover();
                    // this.getPortfolioComment();
                    // this.stepsActive = 1;
                } else if (value === 'Pending') {
                    this.mode = 'View';
                    this.clear('changeAction');
                    this.currentPortfolioID = portfolioID;
                    this.getPortfolio('');
                    this.checkApprover();
                    this.getPortfolioComment();
                    this.stepsActive = 1;
                } else if (value === 'Approver') {
                    this.mode = 'View';
                    this.clear('changeAction');
                    this.currentPortfolioID = portfolioID;
                    this.getPortfolio('');
                    this.checkApprover();
                    this.getPortfolioComment();
                    this.stepsActive = 1;
                } else if (value === 'Reject') {
                    this.mode = 'View';
                    this.clear('changeAction');
                    this.currentPortfolioID = portfolioID;
                    this.getPortfolio('');
                    this.checkApprover();
                    this.getPortfolioComment();
                    this.stepsActive = 1;
                } else if (value === 'ApproverWithLink') {
                    this.mode = 'View';
                    this.clear('changeAction');
                    this.getPortfolio(portfolioID);
                }
            },
            currentDdlLearningMomentsList(type){
                let finalResult = [];
                let notAddedIndicator = [];

                this.ddlLearningMomentsList.forEach(m => {
                    let checkIndicator = this.selectedLearningMomentsListInt.filter(m2 => m2.PlnStaIndicator === m.PlnStaIndicator);

                    if (checkIndicator.length < 1) {
                        notAddedIndicator.push(m);
                    }
                });

                if (type === 'Indicator' && this.ddlDomain !== '') {
                    finalResult = notAddedIndicator.filter(m => m.PlnStaDomain === this.ddlDomain);
                } else if (type === 'Domain') {
                    notAddedIndicator.forEach(m => {
                        let checkDomain = finalResult.filter(m2 => m2.PlnStaDomain === m.PlnStaDomain);

                        if (checkDomain.length < 1) {
                            finalResult.push(m);
                        }
                    });
                }

                return finalResult;
            },
            addIndicator(){
                let getSelected = this.ddlLearningMomentsList.filter(m2 => m2.PlnStaIndicator === this.ddlIndicator);

                this.selectedLearningMomentsListInt.push(getSelected[0]);

                this.ddlIndicator = '';
                this.ddlDomain = '';
            },
            removeIndicator(row){
                this.selectedLearningMomentsListInt = this.selectedLearningMomentsListInt.filter(m2 => m2.PlnStaIndicator !== row.PlnStaIndicator);
            },
            hideShowRemark(){
                if (this.remarkAll) {
                    this.remarkAll = false;
                } else {
                    this.remarkAll = true;
                }
            },
            addFiles(files){
                files.forEach(item => {
                    let boolIsImage = this.isImage(item);
                    let boolIsVideo = this.isVideo(item);

                    if(boolIsImage) {
                        this.editor.addComponents('<div><img src="' + item.FilePath + '"></div>');
                    } else if(boolIsVideo) {
                        this.editor.addComponents('<div><video src="' + item.FilePath + '" controls="controls"></video></div>');
                    }
                });
            },
            isImage(obj_File) {
                let ext = String(obj_File.GalFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },
            isVideo(obj_File) {
                let ext = String(obj_File.GalFileExt).toUpperCase();
                let isVideo = false;

                switch (ext) {
                    case ".MP4":
                        isVideo = true;
                        break;
                    default:
                        isVideo = false;
                        break;
                }

                return isVideo;
            },
            isAudio(obj_File) {
                let ext = String(obj_File.GalFileExt).toUpperCase();
                let isAudio = false;

                switch (ext) {
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                        isAudio = true;
                        break;
                    default:
                        isAudio = false;
                        break;
                }

                return isAudio;
            },
            nextStep() {
                if (this.stepsActive === 0){
                    if (this.ddlClass === '' || this.ddlStudent === '') {
                        this.$notify.error({
                            title: 'Required',
                            message: 'Please select student...'
                        });
                    } else {
                        if (this.displayType === 'new'){
                            this.action('New', '');
                        }
                        this.stepsActive ++ ;
                    }
                } else if (this.stepsActive === 1){
                    this.stepsActive ++ ;
                } else if (this.stepsActive === 999) {
                    if (this.selectedCopyStudentPortfolioID === '') {
                        this.$notify({
                            title: 'Required',
                            message: 'Please Select Moments....'
                        });
                    } else {
                        this.copyPortfolio();
                        this.stepsActive = 1
                    }
                }
            },
            previousStep(){
                if (this.stepsActive === 1){
                    this.stepsActive -- ;
                } else if (this.stepsActive === 2) {
                    this.stepsActive -- ;
                } else if (this.stepsActive === 999) {
                    this.stepsActive = 0;
                }
            },
            backToList(){
                this.stepsActive = 0 ;
                this.clear('All');
            },
            editorHandleUpload (files) {
                // console.log('uploading:', files);
                return new Promise(resolve => {
                    resolve({
                        files: files,
                        status: 200
                    })
                });
            },
            editorHandleSave (data) {
                // console.log('saving:', data);
                this.editorValue = data;
            },
            clearEditor_zz(){
			    let objLayer = $('.layer-list li');

			    if(objLayer.length > 0){
                    $('.layer-list li').each(function(){
                        $(this).click();
                    });

                    let objEditor = $('.tooltip-bottom');

                    $('#viewport .screen .layer').each(function() {
                        for (var a = 0; a < objEditor.length; a++) {
                            if ($('.tooltip-bottom')[a].innerText.trim() === '删除') {
                                $('.tooltip-bottom')[a].click();
                            }
                        }
                    });
                }
            },
            clearEditor(){
			    this.editorScreenHight = 1122;

                window.localStorage.removeItem('vpd-data');

                // let data='{"top":0,"zoom":64,"type":"braid-txt","index":-1,"uuid":-1,"counter":0,"originX":0,"originY":0,"startX":0,"startY":0,"moving":false,"animation":[],"playState":false,"activeElement":{"page":true,"title":"测试页面","height":1500,"endTime":"2020-07-08T02:15:19.948Z","backgroundColor":"#fff"},"page":{"page":true,"title":"测试页面","height":1500,"endTime":"2020-07-08T02:15:19.948Z","backgroundColor":"#fff"},"widgets":[]}';
                let data='{"top":0,"zoom":50,"type":"page","index":-1,"uuid":null,"counter":0,"originX":0,"originY":0,"startX":0,"startY":0,"moving":false,"animation":[],"playState":false,"activeElement":{"page":true,"title":"测试页面","height":1122,"endTime":"2020-07-08T04:03:58.042Z","backgroundColor":"#fff"},"page":{"page":true,"title":"测试页面","height":1122,"endTime":"2020-07-08T04:03:58.042Z","backgroundColor":"#fff"},"widgets":[]}';

                this.editorValue = JSON.parse(data);
                this.isRerender = false;
                $(".delete-selected-item-container .btn-delete-selected").remove();

                this.$nextTick(() => {
                    // Add the component back in
                    this.isRerender = true;
                });
            },
            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            return new File([buf], filename, {type: mimeType});
                        })
                );
            },
            updateEditorPage(value){
			    if (value === 'Add') {
                    this.editorScreenHight += 1122;
                    this.editorValue.page.height = this.editorScreenHight;
                } else if (value === 'Delete') {
			        if (this.editorScreenHight > 1122) {
                        this.editorScreenHight -= 1122;
                        this.editorValue.page.height = this.editorScreenHight;
                    }
                } else {
			        console.log('updateEditorPage error...');
			        return;
                }

                this.isRerender = false;
                $(".delete-selected-item-container .btn-delete-selected").remove();
                
                this.$nextTick(() => {
                    this.isRerender = true;
                });
            },
            addDividerForEditor(){
                let currentHeight = 1122;

                while (currentHeight < this.editorScreenHight) {
                    $('#viewport .screen').append("<div class='EditorPageBreak'>Page Break 分页符</div>");
                    currentHeight += 1122;
                }
            },
            copyStudent(){
                if (this.displayType === 'new'){
                    let copyStudentID = this.ddlCopyStudent;
                    this.$tours['momentTourName'].stop();

                    this.action('New', '');
                    this.stepsActive = 999 ;
                    this.LoadPortfolioList(copyStudentID);
                }

                this.copyMomentTourName = false;
            },
            selectCopyPortfolio(value){
                this.selectedCopyStudentPortfolioID = value.PortfolioID;
                this.selectedCopyStudentPortfolioTitle = value.PortfolioTitle;
            },
            async copyPortfolio(){
                try {
                    const response = await DataSource.shared.getPortfolioHeaderDetails(this.selectedCopyStudentPortfolioID, '');
                    if (response) {
                        if (response.code === '2') {
                            console.log('Get Portfolio Header Details: No Record');
                        } else if (response.code === '99') {
                            console.log('Get Portfolio Header Details: Error');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            let objGetEditorHeight = JSON.parse(response.HeaderTable.Table[0].PortfolioTempCss);
                            this.editorScreenHight = objGetEditorHeight.page.height;

                            window.localStorage.setItem('vpd-data', response.HeaderTable.Table[0].PortfolioTempCss);
                            let data = window.localStorage.getItem('vpd-data');
                            this.editorValue = JSON.parse(data);
                            this.isRerender = false;
                            this.$nextTick(() => {
                                this.isRerender = true;
                            });

                            // this.portfolioIitle = response.HeaderTable.Table[0].PortfolioTitle;

                            response.LearningMoments.Table.forEach(m => {
                                let check = this.ddlLearningMomentsList.filter(m2 => m2.PlnStaIndicator === m.PortfolioLMIndicator);

                                if (check.length>0) {
                                    let tempDs = {
                                        Included: 'No',
                                        PlnStaDomain: m.PortfolioLMDomain,
                                        PlnStaGoals: m.PortfolioLMGoals,
                                        PlnStaIndicator: m.PortfolioLMIndicator,
                                    };

                                    this.selectedLearningMomentsListInt.push(tempDs);
                                }
                            });
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            momentTourStart() {
			    this.tourRunning = true;
                this.$tours['momentTourName'].start();
            },
            momentTourNexPreviousStep(tour, nextOrPreviousStep) {
			    let nextStep = 0;

                if (nextOrPreviousStep === 'Next') {
                    tour.nextStep();
                    nextStep = tour.currentStep + 1;
                } else if (nextOrPreviousStep === 'Previous') {
                    tour.previousStep();
                    nextStep = tour.currentStep - 1;
                } else if (nextOrPreviousStep === 'Stop') {
                    this.tourRunning = false;
                    tour.stop();
                    nextStep = 9999;
                }

                if (nextStep === 2 || nextStep === 3) {
                    this.copyMomentTourName = true;
                } else {
                    this.copyMomentTourName = false;
                }
            },
            momentEditTourStart() {
                this.tourRunning = true;
                this.$tours['momentEditTourName'].start();
            },
            momentEditTourNexPreviousStep(tour, nextOrPreviousStep) {
                let nextStep = 0;

                if (nextOrPreviousStep === 'Next') {
                    tour.nextStep();
                    nextStep = tour.currentStep + 1;
                } else if (nextOrPreviousStep === 'Previous') {
                    tour.previousStep();
                    nextStep = tour.currentStep - 1;
                } else if (nextOrPreviousStep === 'Stop') {
                    this.tourRunning = false;
                    tour.stop();
                    nextStep = 9999;
                }

                if (nextStep === 2) {
                    this.momentEditDraftListRedBorder = true;
                } else {
                    this.momentEditDraftListRedBorder = false;
                }
            },
        },
        updated: function () {
            this.$nextTick(function (e) {
                // Code that will run only after the
                // entire view has been re-rendered
                $('.tab-item a').each(function(index, val) {
                    if (index === 2) {
                        $(this).css("display", "none");
                    }
                });

                $('.widget-list li').each(function(index, val) {
                    if (index !== 2) {
                        $(this).css("display", "none");
                    }
                });

                this.addDividerForEditor();

                $(".menu-bar.toolbar.column").appendTo(".control-panel.column");

                $(".delete-selected-item-container .btn-delete-selected").each(function( index ) {
                    if (index > 0) {
                        $(".delete-selected-item-container .btn-delete-selected")[index].remove();
                    }
                });
                $(".navbar-section .btn-delete-selected").appendTo(".delete-selected-item-container");
            })
        },
    }
</script>

<style scoped>
    #portfolio_component{
        background: #FFFFFF;
    }
    .row{
        margin-right: 0;
        margin-left: 0;
    }
    .stepStep{
        background: #536170;
    }
    .elStep{
        height: 300px;
        margin-top: 100px;
        margin-left: -26px;
    }
    .searchAreaTitle, .informationTitle {
        text-align: center;
        margin-bottom: 10px;
    }
    .searchAreaTitle label, .informationTitle label {
        display: inline !important;
    }
    .searchAreaTitleSelectClassStudent, .informationTitleIndicator {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        color: #4F4F4F;
    }
    .searchAreaTitle, .informationTitle {
        margin-top: 20px;
    }
    .editor {
        margin-top: 20px;
        text-align: left;
        margin-bottom: 100px;
    }
    .searchAreaContent, .informationContent{
        margin-top: 100px;
        text-align: left;
        margin-bottom: 200px;
    }
    .pro-edt-select {
        width: 100%;
        background: #F8FAFF;
    }
    .searchAreaContentSelectClass, .searchAreaContentSelectStudent, .informationContentTitle, .informationContentIndicator {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #91A3B6;
    }
    .informationContentEach {
        margin-bottom: 20px;
    }
    .divButton {
        background: #F8FAFF;
        padding: 10px;
    }
    .divButtonLeft {
        text-align: left;
    }
    .divButtonRight {
        text-align: right;
    }
    .buttonPreviousStep, .nextNextStep {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
        background: #426DFF;
        border-radius: 5px;
    }
    .btnSubmit {
        background: #EA4C89;
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
    }
    .btnDraft {
        background: #91A3B6;
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
    }
    .searchAreaTitleList, .informationTitleList {
        text-align: left;
        margin-bottom: 10px;
        margin-top: 20px;
        padding: 10px;
    }
    .searchAreaTitleList label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 21px;
        color: #4F4F4F;
    }
    .searchAreaContentList, .informationContentList {
        margin-top: 30px;
        text-align: left;
        margin-bottom: 10px;
    }
    .searchAreaTitleBackToList {
        text-align: right;
    }
    .buttonBackToList {
        background: #426DFF;
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
    }
    .informationTitleClassStudentList{
        background: #F8FAFF;
        padding: 15px;
    }
    .selectedClassStudentLabel{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #536170;
    }
    .btnReject{
        background: #91A3B6;
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
    }
    .btnApprove{
        background: #19B600;
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
    }
    hr {
        border: 1px solid #E9EDF7;
    }
    .selfEditorFuncDiv {
        text-align: left;
        margin: 20px 0 0 20px;
    }
    .redborder{
        border: 1px solid red;
    }
</style>

<style>
    #portfolio_component .el-input__inner{
        background: #F8FAFF;
    }
    #portfolio_component .indicatorTable .el-table__header-wrapper th {
        background: #E9EDF7;
    }
    #portfolio_component .indicatorTable .el-table__row td, #portfolio_component .indicatorTable .el-table__empty-block {
        background: #F8FAFF;
    }
    #portfolio_component .listTable .el-table__header-wrapper th {
        background: #E9EDF7;
    }
    #portfolio_component .listTable .el-table__row td, #portfolio_component .indicatorTable .el-table__empty-block {
        background: #F8FAFF;
    }
    #portfolio_component #gjs-sm-extra, #portfolio_component #gjs-sm-display {
        display: none !important;
    }
    #portfolio_component .gjs-pn-options .fa-code, #portfolio_component .gjs-pn-views .fa-bars {
        display: none !important;
    }
    #portfolio_component .gjs-clm-tags, #portfolio_component #gjs-sm-text-shadow {
        display: none !important;
    }
    #portfolio_component #gjs-sm-box-shadow, #portfolio_component #gjs-sm-background {
        display: none !important;
    }
    #portfolio_component #gjs-sm-float {
        display: none !important;
    }
    #portfolio_component .editor .header{
        display: none !important;
    }
    #portfolio_component .columns.col-gapless > .column {
        width: 300px;
    }
    #portfolio_component .toolbar.column {
        width: auto;
    }
    #portfolio_component .panel-wrap.title-panel .panel-row:nth-child(1),
    #portfolio_component .panel-wrap.title-panel .panel-row:nth-child(2),
    #portfolio_component .panel-wrap.title-panel .panel-row:nth-child(4){
        display: none;
    }
    #portfolio_component .selected-panel {
        display: none;
    }
    #portfolio_component .lz-image img {
        width: 100%;
        height: 100%;
    }
    #portfolio_component .tooltip {
        opacity: 1;
    }
    #portfolio_component .screen {
        min-width: 750px;
        overflow: hidden;
    }
    #portfolio_component .EditorPageBreak {
        height: 40px;
        background-color: #91A3B6;
        margin-top: 1102px;
        color: white;
        text-align: center;
        font-size: 20px;
        padding-top: 5px;
    }

    #portfolio_component .btn-delete-selected {
        background: #91A3B6;
        border-radius: 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FFFFFF;
        padding: 11px;
    }

    #portfolio_component .delete-selected-item-container {
        float: left;
        margin-right: 10px;
    }

    @media (max-width: 1025px) {
        /* #portfolio_component .screen {
            min-width: 500px;
        } */

        #portfolio_component .columns.col-gapless > .column {
            width: 250px;
        }
    }
</style>